package org.hs_soft.runmynesto.domain.usecase.options.cash_register_config

import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.tse_location.TSELocationModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.TSELocationsRepository


class TSELocationsUseCase(
    private val repository: TSELocationsRepository
) {
    suspend operator fun invoke(
       id:String,
    ): TSELocationModel {
        return repository.getTSELocations(
            id=id
        )
    }
}